module.exports = __webpack_public_path__ + "img/adaptation_plan.4b86f1bb.svg";